"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _map = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/map"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _angieslistReactComponents = require("angieslist-react-components");
require("./ratingDetails.scss");
var RatingDetails = function RatingDetails(_ref) {
  var ratingDetails = _ref.ratingDetails,
    title = _ref.title,
    customClass = _ref.customClass,
    customId = _ref.customId;
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: customId,
    className: "ratings-details-wrapper ".concat(customClass),
    "aria-label": "rating details of ".concat(title)
  }, /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Grid, {
    className: "rating-details-composite"
  }, title && title !== '' ? /*#__PURE__*/_react["default"].createElement("p", {
    className: "rating-details-title"
  }, title) : null, (0, _map["default"])(ratingDetails).call(ratingDetails, function (ratingDetail) {
    return /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.Col, {
      xs: 6,
      className: "rating-detail-column",
      key: ratingDetail.ratingName
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "rating-detail-title"
    }, ratingDetail.ratingName), /*#__PURE__*/_react["default"].createElement(_angieslistReactComponents.RatingDisplay, {
      ratingLocation: "right",
      rating: ratingDetail.ratingValue,
      starSize: "1em",
      ratingFontSize: "1em"
    }));
  })));
};
RatingDetails.propTypes = {
  ratingDetails: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    ratingName: _propTypes["default"].string,
    ratingValue: _propTypes["default"].number
  })),
  title: _propTypes["default"].string,
  customClass: _propTypes["default"].string,
  customId: _propTypes["default"].string
};
RatingDetails.defaultProps = {
  ratingDetails: [],
  title: '',
  customClass: '',
  customId: 'Rating-Details'
};
var _default = exports["default"] = RatingDetails;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-composed-components/lib/ratings/ratingDetails.js
// module id = 6459
// module chunks = 25